import { and, asc, eq } from "drizzle-orm";
import {
  customer,
  loyalty_movement,
  type PowerSyncDrizzleDB,
  promotion,
} from "@comandero/powersync";
import {
  liveCustomerFilters,
  liveLoyaltyMovementFilters,
  livePromotionFilters,
} from "../live/filters";

export function getCustomersQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(customer)
    .where(and(eq(customer.organization_id, organizationId), ...liveCustomerFilters()))
    .orderBy(asc(customer.name));
}

// Id-scoped lookup (keyed): detail by id; viewing a deleted row is harmless.
export function getCustomerByIdQuery(db: PowerSyncDrizzleDB, customerId: string) {
  return db.select().from(customer).where(eq(customer.id, customerId)).limit(1);
}

export function getLoyaltyMovementsQuery(db: PowerSyncDrizzleDB, customerId: string) {
  return db
    .select()
    .from(loyalty_movement)
    .where(and(eq(loyalty_movement.customer_id, customerId), ...liveLoyaltyMovementFilters()));
}

export function getPromotionsQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(promotion)
    .where(and(eq(promotion.organization_id, organizationId), ...livePromotionFilters()))
    .orderBy(asc(promotion.name));
}
